<!-- Main Content -->
<div class="main-content container">
  <!-- Sidebar -->
  <aside class="sidebar">
    <div class="sidebar-title">Admin Tools</div>
    <ul class="sidebar-menu">
      <li><a href="#" (click)="$event.preventDefault(); showSection('dashboard')"
        [class.active]="activeSection === 'dashboard'"><i class="fas fa-tachometer-alt"></i> Dashboard
      Overview</a></li>
      @if (authorization.hasPermission(permissions.ApplicationReview) && hasApplicationsToReview) {
        <li><a href="#"
          (click)="$event.preventDefault(); showSection('applications')"
          [class.active]="activeSection === 'applications'"><i class="fas fa-search"></i> Review
        Applications</a></li>
      }
      <li><a href="#" (click)="$event.preventDefault(); showSection('documents')"
        [class.active]="activeSection === 'documents'"><i class="fas fa-file-upload"></i> Verify
      Documents</a></li>
      @if (authorization.hasPermission(permissions.FlightRequestView)) {
        <li><a href="#"
          (click)="$event.preventDefault(); showSection('flights')"
          [class.active]="activeSection === 'flights'"><i class="fas fa-plane"></i> Flight
        Requests</a></li>
      }
      @if (authorization.hasPermission(permissions.AwardView)) {
        <li><a href="#"
          (click)="$event.preventDefault(); showSection('awards')"
          [class.active]="activeSection === 'awards'"><i class="fas fa-award"></i> Scholarship
        Awards</a></li>
      }
      @if (authorization.hasAnyPermission(permissions.ClaimView, permissions.ExpenseView)) {
        <li><a href="#"
          (click)="$event.preventDefault(); showSection('expenses')"
          [class.active]="activeSection === 'expenses'"><i class="fas fa-receipt"></i> Expenses</a></li>
      }
      @if (authorization.hasPermission(permissions.AwardView)) {
        <li><a href="#"
          (click)="$event.preventDefault(); showSection('progress')"
          [class.active]="activeSection === 'progress'"><i class="fas fa-chart-line"></i> Progress
        Reports</a></li>
      }
      @if (authorization.hasAnyPermission(permissions.ScholarshipTemplateView, permissions.ScholarshipCreate, permissions.ScholarshipEdit, permissions.ScholarshipDelete)) {
        <li
          >
          <a href="#" (click)="$event.preventDefault(); showSection('scholarship')"
            [class.active]="activeSection === 'scholarship'"><i class="fas fa-plus-circle"></i> Scholarship
          Management</a></li>
        }
        @if (authorization.hasPermission(permissions.EventManage)) {
          <li><a href="#" (click)="$event.preventDefault(); showSection('events')"
            [class.active]="activeSection === 'events'"><i class="fas fa-calendar-plus"></i> Events</a>
          </li>
        }
        <li><a href="#" (click)="$event.preventDefault(); showSection('sponsors')"
          [class.active]="activeSection === 'sponsors'"><i class="fas fa-briefcase"></i> Manage Sponsors</a>
        </li>
        <li><a href="#" (click)="$event.preventDefault(); showSection('reports')"
          [class.active]="activeSection === 'reports'"><i class="fas fa-file-export"></i> Generate Reports</a>
        </li>
        @if (authorization.hasPermission(permissions.UserManage)) {
          <li><a href="#"
            (click)="$event.preventDefault(); showSection('users')"
            [class.active]="activeSection === 'users'"><i class="fas fa-user-shield"></i> User Management</a>
          </li>
          <li><a href="#" (click)="$event.preventDefault(); showSection('settings')"
            [class.active]="activeSection === 'settings'"><i class="fas fa-cog"></i> Settings</a></li>
        }
        <li><a href="#" (click)="$event.preventDefault(); showSection('analytics')"
          [class.active]="activeSection === 'analytics'"><i class="fas fa-chart-line"></i> Analytics</a></li>
        </ul>
      </aside>

      <!-- Content Area -->
      <main class="content-area">

        <!-- Dashboard -->
        @if (activeSection === 'dashboard') {
          <div class="content-section">
            <div class="dashboard-overview">
              <div class="dashboard-hero">
                <h2>Dashboard</h2>
                <p>Welcome back. Here is your overview for today.</p>
              </div>
              <div class="dashboard-kpi-grid">
                <article class="dashboard-kpi-card">
                  <div class="kpi-value">{{ activeScholarshipTemplatesCount }}</div>
                  <div class="kpi-label">Active Templates</div>
                  <div class="kpi-meta"> with fields defined</div>
                </article>
                <article class="dashboard-kpi-card">
                  <div class="kpi-value">{{ savedScholarshipsCount }}</div>
                  <div class="kpi-label">Scholarships</div>
                  <div class="kpi-meta">{{ savedScholarshipsCountLabel }}</div>
                </article>
                <article class="dashboard-kpi-card">
                  <div class="kpi-value">{{ applicationsCount }}</div>
                  <div class="kpi-label">Applications</div>
                  <div class="kpi-meta">{{ applicationsCount === 1 ? 'submission received' : 'submissions
                  received' }}</div>
                </article>
                <article class="dashboard-kpi-card">
                  <div class="kpi-value">0</div>
                  <div class="kpi-label">Flagged Ineligible</div>
                  <div class="kpi-meta">No submissions yet</div>
                </article>
              </div>
              <div class="dashboard-content-grid">
                <div class="dashboard-primary-column">
                  <section class="dashboard-panel">
                    <header class="dashboard-panel-header">
                      <h3>Recent Templates</h3>
                      <a href="#"
                        (click)="$event.preventDefault(); showSection('scholarship'); selectScholarshipTab('templates')">View
                      all</a>
                    </header>
                    <div class="dashboard-panel-body no-padding">
                      <table class="dashboard-table">
                        <thead>
                          <tr>
                            <th>Template Name</th>
                            <th>Country</th>
                            <th>Minimum (%)</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          @if (recentTemplates.length === 0) {
                            <tr>
                              <td colspan="5"
                                style="text-align:center; color:var(--text-color); padding: 24px;">No
                              templates created yet.</td>
                            </tr>
                          }
                          @for (template of recentTemplates; track template) {
                            <tr>
                              <td class="row-title">{{ template.name }}</td>
                              <td><span class="country-mini"><strong>{{ template.country.code }}</strong>
                            {{ template.country.name }}</span></td>
                            <td>{{ template.gradePointAverage.minimumPercentage }}</td>
                            <td>
                              <span class="pill"
                                [class.pill-success]="getTemplateStatus(template) === 'COMPLETED'"
                                [class.pill-warning]="getTemplateStatus(template) === 'DRAFT'">
                                {{ getTemplateStatus(template) }}
                              </span>
                            </td>
                            <td><button class="dash-action-btn" type="button"
                            (click)="showSection('scholarship'); selectScholarshipTab('templates')">Edit</button></td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </section>
                <section class="dashboard-panel">
                  <header class="dashboard-panel-header">
                    <h3>Applications</h3>
                    <a href="#" (click)="$event.preventDefault(); showSection('applications')">View all</a>
                  </header>
                  <div class="dashboard-panel-body no-padding">
                    <table class="dashboard-table">
                      <thead>
                        <tr>
                          <th>Reference</th>
                          <th>Applicant</th>
                          <th>Scholarship</th>
                          <th>Submitted</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        @if (applicationsLoading) {
                          <tr>
                            <td colspan="5"
                              style="text-align:center; color:var(--text-color); padding: 24px;">
                            Loading applications…</td>
                          </tr>
                        }
                        @if (!applicationsLoading && applicationsError) {
                          <tr>
                            <td colspan="5"
                              style="text-align:center; color:var(--text-color); padding: 24px;">
                            Applications could not be loaded.</td>
                          </tr>
                        }
                        @if (!applicationsLoading && !applicationsError && recentApplications.length === 0) {
                          <tr
                            >
                            <td colspan="5"
                              style="text-align:center; color:var(--text-color); padding: 24px;">No
                              applications found. Applications will appear here once students begin
                            applying.</td>
                          </tr>
                        }
                        @for (application of recentApplications; track application) {
                          <tr>
                            <td class="row-title">{{ application.referenceNumber }}</td>
                            <td>{{ getApplicantName(application) }}</td>
                            <td>{{ application.scholarship?.title || 'Unknown scholarship' }}</td>
                            <td>{{ application.applicationDate | date: 'dd MMM yyyy' }}</td>
                            <td><span class="pill pill-warning">{{ application.applicationStatus?.name
                            || 'Unknown' }}</span></td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </section>
              </div>
              <aside class="dashboard-side-column">
                <section class="dashboard-panel">
                  <header class="dashboard-panel-header panel-title-muted">
                    <h3>Quick Actions</h3>
                  </header>
                  <div class="dashboard-panel-body quick-actions-panel">
                    @if (authorization.hasPermission(permissions.ScholarshipTemplateManage)) {
                      <a href="#"
                        (click)="$event.preventDefault(); showSection('scholarship'); selectScholarshipTab('templates')"><span
                      class="dot dot-blue"></span>Create New Template</a>
                    }
                    @if (authorization.hasAnyPermission(permissions.ScholarshipCreate, permissions.ScholarshipEdit, permissions.ScholarshipDelete)) {
                      <a
                        href="#"
                        (click)="$event.preventDefault(); showSection('scholarship'); selectScholarshipTab('scholarships')"><span
                      class="dot dot-green"></span>Manage Scholarships</a>
                    }
                    <a href="#"
                      (click)="$event.preventDefault(); showSection('scholarship'); selectScholarshipTab('audit')"><span
                    class="dot dot-gold"></span>View Audit Log</a>
                    <a href="#" (click)="$event.preventDefault(); showSection('reports')"><span
                    class="dot dot-teal"></span>Generate Reports</a>
                  </div>
                </section>
                <section class="dashboard-panel">
                  <header class="dashboard-panel-header panel-title-muted">
                    <h3>Template Summary</h3>
                  </header>
                  <div class="dashboard-panel-body app-metrics-panel">
                    <div class="metric-item">
                      <div class="metric-row"><span>Total Templates</span><strong>{{ savedTemplates.length
                    }}</strong></div>
                    <div class="metric-bar"><span class="fill navy"
                    [style.width.%]="savedTemplates.length > 0 ? 100 : 0"></span></div>
                  </div>
                  <div class="metric-item">
                    <div class="metric-row"><span>Active</span><strong>{{
                  activeScholarshipTemplatesCount }}</strong></div>
                  <div class="metric-bar"><span class="fill navy"
                  [style.width.%]="savedTemplates.length > 0 ? (activeScholarshipTemplatesCount / savedTemplates.length) * 100 : 0"></span>
                </div>
              </div>
              <div class="metric-item">
                <div class="metric-row"><span>Draft</span><strong>{{ savedTemplates.length -
              activeScholarshipTemplatesCount }}</strong></div>
              <div class="metric-bar"><span class="fill gold"
              [style.width.%]="savedTemplates.length > 0 ? ((savedTemplates.length - activeScholarshipTemplatesCount) / savedTemplates.length) * 100 : 0"></span>
            </div>
          </div>
        </div>
      </section>
    </aside>
  </div>
</div>
</div>
}

<!-- Review Applications -->
@if (activeSection === 'applications') {
  <div class="content-section">
    <div class="card">
      <div class="card-header">Applications Management</div>
      <div class="card-body">
        <app-admin-applications></app-admin-applications>
      </div>
    </div>
  </div>
}

<!-- User Management -->
@if (activeSection === 'users' && authorization.hasPermission(permissions.UserManage)) {
  <div class="content-section">
    <div class="card">
      <div class="card-header">User Management</div>
      <div class="card-body">
        <app-admin-users></app-admin-users>
      </div>
    </div>
  </div>
}

<!-- Flight Requests -->
@if (activeSection === 'flights' && authorization.hasPermission(permissions.FlightRequestView)) {
  <div class="content-section">
    <div class="card">
      <div class="card-header">Flight Booking Requests</div>
      <div class="card-body">
        <app-admin-flight-requests></app-admin-flight-requests>
      </div>
    </div>
  </div>
}

<!-- Verify Documents -->
@if (activeSection === 'documents' && authorization.hasPermission(permissions.ApplicationReview)) {
  <div class="content-section">
    <div class="card">
      <div class="card-header">Document Verification</div>
      <div class="card-body">
        <app-admin-documents></app-admin-documents>
      </div>
    </div>
  </div>
}

<!-- Add New Scholarship (Templates / Scholarships / Audit Log) -->
@if (activeSection === 'scholarship') {
  <div class="content-section">
    <div class="card">
      <div class="card-header">Scholarship Management</div>
      <div class="card-body">
        <div class="scholarship-tabs">
          @if (authorization.hasPermission(permissions.ScholarshipTemplateView)) {
            <button type="button"
              class="scholarship-tab-btn" [class.active]="activeScholarshipTab === 'templates'"
              (click)="selectScholarshipTab('templates')">
              Scholarship Templates
            </button>
          }
          @if (authorization.hasAnyPermission(permissions.ScholarshipCreate, permissions.ScholarshipEdit, permissions.ScholarshipDelete)) {
            <button
              type="button" class="scholarship-tab-btn"
              [class.active]="activeScholarshipTab === 'scholarships'"
              (click)="selectScholarshipTab('scholarships')">
              Scholarships
            </button>
          }
          <button type="button" class="scholarship-tab-btn"
            [class.active]="activeScholarshipTab === 'audit'" (click)="selectScholarshipTab('audit')">
            Audit Log
          </button>
        </div>
        @if (activeScholarshipTab === 'templates' && authorization.hasPermission(permissions.ScholarshipTemplateView)) {
          <app-admin-templates
          ></app-admin-templates>
        }
        @if (activeScholarshipTab === 'scholarships' && authorization.hasAnyPermission(permissions.ScholarshipCreate, permissions.ScholarshipEdit, permissions.ScholarshipDelete)) {
          <app-admin-scholarships
            (viewScholarshipRequest)="openScholarship($event.id)"
          ></app-admin-scholarships>
        }
        @if (activeScholarshipTab === 'audit') {
          <app-admin-audit-log></app-admin-audit-log>
        }
      </div>
    </div>
  </div>
}

<!-- One scholarship: cycle status, budget, awarded students and applications -->
@if (activeSection === 'scholarship-cycle' && selectedScholarshipId) {
  <div class="content-section">
    <app-admin-scholarship-cycle [scholarshipId]="selectedScholarshipId"
      [cycle]="selectedScholarshipCycle" (back)="backToScholarships()">
    </app-admin-scholarship-cycle>
  </div>
}

<!-- Events -->
@if (activeSection === 'events' && authorization.hasPermission(permissions.EventManage)) {
  <div class="content-section">
    <div class="card">
      <div class="card-header">Events Management</div>
      <div class="card-body">
        <app-admin-events></app-admin-events>
      </div>
    </div>
  </div>
}

<!-- Sponsors -->
@if (activeSection === 'sponsors') {
  <div class="content-section">
    <div class="card">
      <div class="card-header">Sponsors Management</div>
      <div class="card-body" style="text-align:center; padding: 40px; color:var(--text-color);">Coming soon.
      </div>
    </div>
  </div>
}

<!-- Reports -->
@if (activeSection === 'reports' && authorization.hasPermission(permissions.ReportsView)) {
  <div class="content-section">
    <div class="card">
      <div class="card-header">Generate Reports</div>
      <div class="card-body">
        <app-admin-reports></app-admin-reports>
      </div>
    </div>
  </div>
}

<!-- Scholarship Awards -->
@if (activeSection === 'awards' && authorization.hasPermission(permissions.AwardView)) {
  <div class="content-section">
    <div class="card">
      <div class="card-header">Scholarship Awards</div>
      <div class="card-body">
        <app-admin-awards></app-admin-awards>
      </div>
    </div>
  </div>
}

<!-- Expenses: the claim queue and the recurring payment/settlement queue as tabs -->
@if (activeSection === 'expenses' && authorization.hasAnyPermission(permissions.ClaimView, permissions.ExpenseView)) {
  <div class="content-section">
    <div class="card">
      <div class="card-header">Expenses</div>
      <div class="card-body">
        <div class="scholarship-tabs">
          @if (authorization.hasPermission(permissions.ClaimView)) {
            <button type="button" class="scholarship-tab-btn" [class.active]="activeExpenseTab === 'claims'"
              (click)="selectExpenseTab('claims')">Expense Claims</button>
          }
          @if (authorization.hasPermission(permissions.ExpenseView)) {
            <button type="button" class="scholarship-tab-btn" [class.active]="activeExpenseTab === 'payments'"
              (click)="selectExpenseTab('payments')">Recurring Payments</button>
          }
        </div>

        @if (activeExpenseTab === 'claims' && authorization.hasPermission(permissions.ClaimView)) {
          <app-admin-claims></app-admin-claims>
        }
        @if (activeExpenseTab === 'payments' && authorization.hasPermission(permissions.ExpenseView)) {
          <app-admin-expenses></app-admin-expenses>
        }
      </div>
    </div>
  </div>
}

<!-- Academic progress reports -->
@if (activeSection === 'progress' && authorization.hasPermission(permissions.AwardView)) {
  <div class="content-section">
    <div class="card">
      <div class="card-header">Academic Progress Reports</div>
      <div class="card-body">
        <app-admin-progress-reports></app-admin-progress-reports>
      </div>
    </div>
  </div>
}

</main>
</div>
